export default function initPortfolio(){
    jQuery(".brandLogo").on('click',function(){
        const targetId = jQuery(`#${jQuery(this).data('target')}`)
        jQuery('html, body').animate({
            scrollTop: targetId.offset().top
        }, 2000);
    })

    function translateY(element, y = 0) {
        element.style.transform = `translateY(${y})`;
        element.style.webkitTransform = `translateY(${y})`;
        element.style.mozTransform = `translateY(${y})`;
        element.style.msTransform = `translateY(${y})`;
        element.style.oTransform = `translateY(${y})`;
    }

    const spans = document.querySelectorAll(".rotater span");
    let index = 0;
    let prev = -1;

    function animate() {
        spans.forEach((span, i) => {

            // span.style.opacity = i === index ? 1 : 0; 

            // setTimeout(() => {
            //     // console.log("index:"+index)
            //     span.style.opacity = i === index ? 1 : 0; 
            //     if(index === i) {
            //         console.log('index'+ index);
                    
            //     }
            // }, 2000);

            if (prev === i) {
                // setTimeout(() => {
                    translateY(span, "-30px");
                    span.style.opacity = 0;
                // }, 1000)
            } else if (index === i ){
                setTimeout(() => {
                    console.log(span)
                    span.style.opacity = 1;
                    translateY(span, "0px");
                }, 1500);
            } else {
                // setTimeout(() => {
                translateY(span, "30px");
                // }, 1000);
            }
        });

        prev = index;
        index = (index + 1) % spans.length;
        console.log(index)
        setTimeout(() => requestAnimationFrame(animate), 4000); // 2-second delay
    }
animate();
}